import { AlertDialog } from "@hamlak/ui";
import { t } from "@/i18n/ko";

/** F04-04 확인 – 대화방 나가기. inactive 캐릭터면 다시 시작할 수 없다는 한 줄을 붙인다(D14). */
export function LeaveDialog({ open, inactive, loading, onConfirm, onCancel }: { open: boolean; inactive: boolean; loading: boolean; onConfirm: () => void; onCancel: () => void }) {
  return (
    <AlertDialog
      open={open}
      tone="critical"
      title={t("leave.title")}
      description={inactive ? `${t("leave.body")} ${t("leave.bodyInactive")}` : t("leave.body")}
      primaryLabel={t("leave.confirm")}
      secondaryLabel={t("common.cancel")}
      loading={loading}
      onPrimary={onConfirm}
      onSecondary={onCancel}
    />
  );
}
